import React from 'react';
import {component_tool} from '@/tool'
import {WizBraftEditorPlus} from '@/containers/common'

let {WizButton, WizSelect, WizIcon, Wizmessage, WizDivider, WizRow, WizCol, WizRadio, WizTooltip, WizCheckbox} = component_tool;
let Option = WizSelect.Option
let OptGroup = WizSelect.OptGroup

export const columnsBase = (self, data) => [
  {
    name: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    name: 'typePropertyIdList',
    formItem: {
      type: 'hidden',
      rules: [{
        required: true,
        message: '属性配置不能为空'
      }]
    }
  },
  {
    title: '知识类型',
    name: 'title',
    formItem: {
      rules: [{
        required: true,
        message: '请输入知识类型'
      }, {
        maxLength: 20,
        message: '知识类型不能超过20个字'
      }
      ],
    }
  },
  {
    title: "前端列表",
    name: "displayType",
    dict: [
      {code: 1, codeName: "文字列表"},
      {code: 2, codeName: "图文列表(左图右文)"},
      {code: 3, codeName: "图文列表(上图下文)"}
    ],
    formItem: {
      type: 'select',
      rules: [{
        required: true,
        message: '请选择前端列表',
      }],
    },
  },
  {
    title: "备注",
    name: "mark",
    formItem: {
      type: 'textarea',
      placeholder: '请输入备注,最多50字',
      maxLength: 50,
    }
  },
  {
    title: "状态",
    name: "state",
    dict: [
      {code: 1, codeName: "启用"},
      {code: 0, codeName: "禁用"}
    ],
    formItem: {
      type: "radio",
      rules: [{
        required: true,
        message: '请选择状态',
      }],
    }
  }
];

export const columnsHighSet = (self, data) => {

  let columns = [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: "内容形式",
      name: "contentTypeList",
      dict: [
        {code: 1, codeName: "文件上传"},
        {code: 2, codeName: "富文本框"},
        {code: 3, codeName: "关联业务"}
      ],
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const {getFieldDecorator} = form;
          let contentTypeList = record.contentTypeList ? record.contentTypeList : [];
          return (<div className='modal-dev-checkbox'>
            <WizRow>
              <WizCol>
                {getFieldDecorator('contentTypeList', {
                  initialValue: contentTypeList,
                  rules: [
                    {required: true, message: '请选择内容形式', type: 'array'},
                  ],
                })(
                  <WizCheckbox.Group onChange={(e) => {
                    if (!e || !(e instanceof Array) || (e instanceof Array && e.length <= 0)) {
                      self.setState({
                        isShowFileTypeList: false,
                        isShowTextContent: false,
                        isShowBusiness:false,
                      });
                    } else {
                      let isShowFileTypeList = false;
                      let isShowTextContent = false;
                      let isShowBusiness = false;
                      e.forEach(item => {
                        if (item === 1) {
                          isShowFileTypeList = true;
                        }
                        if (item === 2) {
                          isShowTextContent = true;
                        }
                        if (item === 3) {
                          isShowBusiness = true;
                        }
                      });
                      self.setState({
                        isShowFileTypeList,
                        isShowTextContent,
                        isShowBusiness
                      });
                    }

                  }}>
                    <WizRow>
                      {self._getCheckbox(1, '文件上传', contentTypeList)}
                      {self._getCheckbox(2, '富文本框', contentTypeList)}
                      {self._getCheckbox(3, '关联业务', contentTypeList)}
                    </WizRow>
                  </WizCheckbox.Group>
                )}
              </WizCol>
            </WizRow>
          </div>)
        }
      },
    },
    self.state.isShowFileTypeList ? {
      title: "文件支持格式",
      name: "fileTypeList",
      dict: [
        {code: 1, codeName: "PDF"},
        {code: 2, codeName: "DOC"},
        {code: 3, codeName: "DOCX"},
        {code: 4, codeName: "XLS"},
        {code: 5, codeName: "XLSX"},
        {code: 6, codeName: "PPT"},
        {code: 7, codeName: "PPTX"},
        {code: 8, codeName: "MP4"},
        {code: 13, codeName: "JPG"},
        {code: 14, codeName: "PNG"},
        {code: 15, codeName: "JPEG"},
      ],
      formItem: {
        type: 'custom',
        render: (record, form) => {
          const {getFieldDecorator} = form;
          let fileTypeList = record.fileTypeList ? record.fileTypeList : [];
          return (<>
            <WizRow>
              <WizCol>
                {getFieldDecorator('fileTypeList', {
                  initialValue: fileTypeList,
                })(
                  <WizCheckbox.Group>
                    <WizRow>
                      {self._getCheckbox(1, 'PDF', fileTypeList)}
                      {self._getCheckbox(2, 'DOC', fileTypeList)}
                      {self._getCheckbox(3, 'DOCX', fileTypeList)}
                      {self._getCheckbox(4, 'XLS', fileTypeList)}
                    </WizRow>
                    <WizRow>
                      {self._getCheckbox(5, 'XLSX', fileTypeList)}
                      {self._getCheckbox(6, 'PPT', fileTypeList)}
                      {self._getCheckbox(7, 'PPTX', fileTypeList)}
                      {self._getCheckbox(8, 'MP4', fileTypeList)}
                    </WizRow>
                    <WizRow>
                      {self._getCheckbox(13, 'JPG', fileTypeList)}
                      {self._getCheckbox(14, 'PNG', fileTypeList)}
                      {self._getCheckbox(15, 'JPEG', fileTypeList)}
                    </WizRow>
                  </WizCheckbox.Group>
                )}
              </WizCol>
            </WizRow>
          </>)
        }
      },
    } : {},
    self.state.isShowTextContent ? {
      title: "富文本框范本",
      formItem: {
        type: 'custom',
        render: (record, form) => {
          return (
            <div>
              <span className="form-column">{'（您可以在富文本框中输入范本，引用此知识类型时可带出）'}</span>
            </div>
          )
        }
      },
    } : {},
    self.state.isShowTextContent ? {
      formItem: {
        type: 'custom',
        col: {span: 24},
        formItemLayout: {
          labelCol: {span: 0},
          wrapperCol: {span: 24}
        },
        render: (record, form) => {
          let height = data && data.propertyList && data.propertyList.length > 0 ? 650 : 450;
          const {getFieldDecorator} = form
          return (
            <>
              {getFieldDecorator('textContent', {
                initialValue: record && record.textContent,
              })(
                <WizBraftEditorPlus links={[0, 1, 2, 3]} style={{height: height}}/>
              )}
            </>
          )
        }
      },
    } : {}
  ];

  return columns;
};


export const columnsProperty = (self, data) => [
  {
    title: "知识点属性",
    name: "name",
    dataIndex: "name",
    width: 120,
    tableItem: {}
  },
  {
    title: "属性类型",
    name: "typeStr",
    dataIndex: "typeStr",
    width: 100,
    tableItem: {}
  },
  {
    title: "属性说明",
    name: "intro",
    dataIndex: "intro",
    ellipsis: true,
    tableItem: {}
  }
];
